module.exports = __webpack_public_path__ + "img/guidance-service-bg.b4340cc4.png";